
const ENABLE_CUSTOM_DATE = false;
const formBeforeDateSelection = document.getElementById("form-before-date-selection");
const booked_opponent = document.querySelector(".booked_opponent");
const booking_form = document.querySelector(".booking-form");
const booking_form_container = document.querySelector(".booking-form-container");
const main_panel = document.querySelector(".main-panel");
const suggestionsDiv = document.querySelector(".suggestions");
const confirmation_form_div = document.getElementById("confirmation_form_div");
const address_form = document.getElementById("address_form");
const custom_date = document.getElementById("custom_date");
const add_location = document.querySelector(".add_location");
const pick_time = document.querySelector(".pick_time");
const steps = document.querySelector(".steps");
const back_btn = document.querySelector(".back_btn");
const loader = document.getElementById("loader");
const Opties_berekenen = document.getElementById("Opties_berekenen");
const new_street = document.getElementById("straatnummer");
const new_postcode = document.getElementById("Postcode");
const new_city = document.getElementById("city");
const invalid = document.querySelector(".invalid");
const again_fil = document.querySelector(".again_fil");
const containers = document.querySelector(".timeslot-container");
const customSelect = document.querySelector(".custom_date_select");
const showCalendarBtn = document.getElementById("showCalendarBtn");
const showCalendarBtnAfterLoad = document.getElementById("showCalendarBtnAfterLoad");
const calendar_container = document.querySelector(".calendar-container");
const taskDropdown = document.getElementById("62460-select-2"); // Target dropdown
const confirmation_summary_div = document.getElementById("confirmation_summary_div");
const custom_date_btn = document.getElementById("custom-date-submit");
const preferredMomentInputs = document.querySelectorAll('input[name="preferred_moment[]"]');
const confirm_appointment = document.querySelector(".confirm_appointment");
const infoBlock = document.getElementById('show-all-times-btn-div-after-load');
const timeslotHint = document.getElementById('timeslot-hint');
let selectedCalendarSlot = null;

function getSelectedPreferredMoments() {
    return Array.from(
        document.querySelectorAll('input[name="preferred_moment[]"]:checked')
    ).map((input) => input.value);
}

function validateCustomDateForm() {
    const selectedMoments = getSelectedPreferredMoments();
    const customText = customDayInput?.value.trim() || "";

    const textareaGroup = customDayInput?.parentElement;
    if (!textareaGroup) return false;

    const oldError = textareaGroup.querySelector(".error-message");
    if (oldError) oldError.remove();

    textareaGroup.classList.remove("invalid");

    if (selectedMoments.length === 0 && customText === "") {
        textareaGroup.classList.add("invalid");

        const error = document.createElement("div");
        error.className = "error-message text-danger small mt-1";
        error.textContent = "Kies minimaal één moment of vul een toelichting in.";
        textareaGroup.appendChild(error);

        return false;
    }

    return true;
}

// validation with email format
function validateAndCollectFormData() {
    const form = document.getElementById("confirmation_form_div");
    const data = {};
    let isValid = true;

    // Email regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Clear only messages — keep .valid / .invalid unless overwritten
    form.querySelectorAll(".error-message").forEach((el) => el.remove());

    // Validate & collect inputs
    form.querySelectorAll("input").forEach((input) => {
        const name = input.name;
        const value = input.value.trim();
        const parent = input.parentElement;

        if (input.disabled || !name) return;

        // Required validation
        if (input.hasAttribute("required") && !value) {
            isValid = false;
            const error = document.createElement("div");
            error.className = "error-message text-danger small mt-1";
            error.textContent = "Dit veld is verplicht.";
            parent.appendChild(error);
            parent.classList.add("invalid");
        }

        // Validate & collect inputs
        if (input.type === "tel" && value) {
            if (!validatePhoneNumber(input)) {
                isValid = false;
            }
        }

        // Email validation
        if ((input.type === "email" || name.toLowerCase() === "email") && value) {
            if (!emailRegex.test(value)) {
                isValid = false;
                const error = document.createElement("div");
                error.className = "error-message text-danger small mt-1";
                error.textContent = "Voer een geldig e-mailadres in.";
                parent.appendChild(error);
                parent.classList.add("invalid");
            }
        }

        if (input.type !== "checkbox") {
            data[name] = value;
        }
    });

    // Aantal ramen select
    const ramenSelect = document.getElementById("62460-select-2");
    const ramenValue = ramenSelect.value.trim();
    const ramenGroup = ramenSelect.parentElement;

    if (!ramenValue) {
        isValid = false;
        const error = document.createElement("div");
        error.className = "error-message text-danger small mt-1";
        error.textContent = "Dit veld is verplicht.";
        ramenGroup.appendChild(error);
        ramenGroup.classList.add("invalid");
    } else {
        data["aantalRamen"] = ramenValue;
        ramenGroup.classList.add("valid"); // ✔ for select
    }

    // Interests (dropdown with checkboxes in #interests-panel)
    const interestsPanel = document.getElementById("interests-panel");
    const interestsDropdown = document.getElementById("interests-dropdown");

    if (interestsPanel && interestsDropdown) {
        const interestCheckboxes = interestsPanel.querySelectorAll(".interest-option");
        const selectedInterests = Array.from(interestCheckboxes)
            .filter((cb) => cb.checked)
            .map((cb) => cb.value);

        // The .form-group wrapper around the dropdown
        const interestsGroup =
            interestsDropdown.closest(".form-group") || interestsDropdown.parentElement;

        // Remove any old error on this field
        const oldError = interestsGroup.querySelector(".error-message");
        if (oldError) oldError.remove();
        interestsGroup.classList.remove("invalid", "valid");

        if (selectedInterests.length === 0) {
            isValid = false;

            const error = document.createElement("div");
            error.className = "error-message text-danger small mt-1";
            error.textContent = "Selecteer minimaal één interesse.";

            interestsGroup.appendChild(error);   // error under the dropdown
            interestsGroup.classList.add("invalid");
        } else {
            data["interests"] = selectedInterests;
            interestsGroup.classList.add("valid");
        }
    }

    return isValid ? data : null;
}

add_location.addEventListener("click", function () {
    const result = validateAndCollectFormData();
    if (result) {
        console.log("Form is valid. Data:", result);

        // Push GTM event
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "button_click_add_adress",
            button_name: "stsrt_adding_adress",
        });

        // hide step-1 CTA, show address form
        add_location.classList.add("hidden");        // <-- NEW
        confirmation_form_div.classList.add("hidden");
        address_form.classList.remove("hidden");
        back_btn.classList.remove("hidden");

        // document.querySelector(".main-panel").scrollIntoView({
        //     behavior: "smooth",
        //     block: "start",
        // });
    } else {
        console.log("Form is invalid.");
    }
});


// === Live validation to remove error messages ===
const liveEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function handleFieldChange(el) {
    const group = el.closest(".form-group");
    if (!group) return;

    const value = el.value.trim();
    let fieldValid = true;

    // required
    if (el.hasAttribute("required") && value === "") {
        fieldValid = false;
    }

    // email format
    if (fieldValid && (el.type === "email" || el.name?.toLowerCase() === "email") && value !== "") {
        if (!liveEmailRegex.test(value)) {
            fieldValid = false;
        }
    }

    const error = group.querySelector(".error-message");

    if (fieldValid) {
        if (error) error.remove();
        group.classList.remove("invalid");
        // only show ✔ when there is actually a value
        if (value !== "") {
            group.classList.add("valid");
        } else {
            group.classList.remove("valid");
        }
    } else {
        // still invalid → no green check
        group.classList.remove("valid");
    }
}

document
    .querySelectorAll("#confirmation_form_div input, #confirmation_form_div select")
    .forEach((el) => {
        // el.addEventListener("input", () => {
        //     handleFieldChange(el);
        //
        //     if (el.type === "tel") {
        //         validatePhoneNumber(el);
        //     }
        // });
        el.addEventListener("change", () => {
            handleFieldChange(el);

            if (el.type === "tel") {
                validatePhoneNumber(el);
            }
        });
    });

// Special case voor interests dropdown
const interestsPanel = document.getElementById("interests-panel");
const interestsDropdown = document.getElementById("interests-dropdown");

if (interestsPanel && interestsDropdown) {
    const interestsGroup = interestsDropdown.closest(".form-group");

    interestsPanel.querySelectorAll(".interest-option").forEach((cb) => {
        cb.addEventListener("change", () => {
            const selected = interestsPanel.querySelectorAll(".interest-option:checked");

            if (!interestsGroup) return;

            if (selected.length > 0) {
                // remove error
                const error = interestsGroup.querySelector(".error-message");
                if (error) error.remove();

                // remove invalid state + add valid state
                interestsGroup.classList.remove("invalid");
                interestsGroup.classList.add("valid");
            } else {
                // unchecked again → remove valid state (but we don't show error until submit)
                interestsGroup.classList.remove("valid");
            }
        });
    });
}

back_btn.addEventListener("click", function () {
    const isConfirmationHidden = confirmation_form_div.classList.contains("hidden");
    const isAddressHidden = address_form.classList.contains("hidden");
    const isSuggestionsHidden = suggestionsDiv.classList.contains("hidden");

    if (isConfirmationHidden && !isAddressHidden) {
        // Case 1: Confirmation is hidden, Address is visible
        confirmation_form_div.classList.remove("hidden");
        address_form.classList.add("hidden");
        back_btn.classList.add("hidden");
    } else if (isConfirmationHidden && isAddressHidden && isSuggestionsHidden) {
        // Case 2: Both confirmation and address are hidden, suggestions are hidden
        suggestionsDiv.classList.remove("hidden");
        custom_date.classList.add("hidden");
        invalid.innerHTML = "";
        // again_fil.innerHTML = "";
    } else if (isConfirmationHidden && isAddressHidden && !isSuggestionsHidden) {
        // Case 3: Both confirmation and address are hidden
        address_form.classList.remove("hidden");
        confirmation_form_div.classList.add("hidden");
        suggestionsDiv.classList.add("hidden");
        invalid.innerHTML = "";
        // again_fil.innerHTML = "";
        containers.innerHTML = "";
    }
});

let Get_more_suggestions = 1;

showCalendarBtn.addEventListener("click", () => {
    const invalid = document.querySelector(".invalid");

    // Push event to GTM
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "button_click_more_proposals",
        button_name: "load_more_proposals",
    });

    // Hide validation message if present
    if (invalid) invalid.classList.add("hidden");

    // Clear existing timeslots
    containers.innerHTML = "";

    const timeSlotRequest = 6;
    const sessionId = localStorage.getItem("sessionID");
    const task_id = localStorage.getItem("task_ID");

    // Request additional suggestions
    cancelSuggesstion(sessionId, task_id, null, timeSlotRequest);

    // Scroll back to the main panel after triggering request
    // setTimeout(() => {
    //     const mainPanel = document.querySelector(".main-panel");
    //     if (mainPanel) {
    //         mainPanel.scrollIntoView({ behavior: "smooth", block: "start" });
    //     }
    // }, 50);

    // Show loading indicator
    Opties_berekenen.classList.remove("hidden");

    Get_more_suggestions++;

    showCalendarBtn.classList.add("hidden");
});

if (showCalendarBtnAfterLoad) {
    showCalendarBtnAfterLoad.addEventListener("click", () => {
        if (!ENABLE_CUSTOM_DATE) return;
        const invalid = document.querySelector(".invalid");

        // Hide validation message if present
        if (invalid) {
            invalid.classList.add("hidden");
        }

        // Hide suggestions and show custom date section
        suggestionsDiv.classList.add("hidden");
        custom_date.classList.remove("hidden");

        // Clear rendered timeslots
        containers.innerHTML = "";

        // Scroll to custom date section
        setTimeout(() => {
            const customDate = document.getElementById("custom_date");
            if (customDate) {
                customDate.scrollIntoView({
                    behavior: "auto",
                    block: "center"
                });
                console.log("Scrolled to #custom_date");
            }
        }, 50);
    });
}

function resetSuggestionCount() {
    Get_more_suggestions = 1;
    console.log("Get_more_suggestions reset to 1");

    // 🔁 Reset buttons to initial state
    if (showCalendarBtn && showCalendarBtnAfterLoad) {
        showCalendarBtn.hidden = false;
        showCalendarBtnAfterLoad.hidden = true;
    }

    if (!ENABLE_CUSTOM_DATE && showCalendarBtnAfterLoad) {
        showCalendarBtnAfterLoad.hidden = true;
    }
}

function getUrlObject() {
    // Use origin + pathname to ensure absolute URL with hash retained separately
    return new URL(window.location.href);
}

// Usage examples:

document.addEventListener("DOMContentLoaded", function () {
    // Automatically trigger the API call on page load
    fetch(`https://phpstack-1418759-5351611.cloudwaysapps.com/api/create/session`)
        .then((response) => response.json())
        .then((data) => {
            if (data.data.session) {
                const session_id = data.data.session._id;
                console.log("session_id", session_id);
                // Store session ID in localStorage
                localStorage.setItem("sessionID", session_id);
                // Fetch data using session ID
                // fetchLocationList(session_id);
                // fetchTaskTypes(session_id);
                formTaskTypes(session_id);
                // formtaglist(session_id);
            } else {
                console.error("Session ID not found in response.");
            }
        })
        .catch((error) => console.error("API Error:", error));

});

// Form tasks types
// function formTaskTypes(session_id) {
//   const url = `https://phpstack-1418759-5351611.cloudwaysapps.com/api/task/types/${session_id}`;

//   fetch(url)
//     .then((response) => response.json())
//     .then((data) => {
//       // Clear existing options except the first one
//       taskDropdown.innerHTML = `<option value="">Selecteer aantal ramen</option>`;

//       if (data.data.taskTypes && data.data.taskTypes.length > 0) {
//         data.data.taskTypes.forEach((task) => {
//           const taskName = task.name?.trim();

//           // Skip if taskName includes "Montage" or is empty after trim
//           if (!taskName || taskName.includes("Montage")) return;

//           const option = document.createElement("option");
//           option.value = task._id;
//           option.classList.add("tasks_list");
//           option.textContent = taskName;
//           taskDropdown.appendChild(option);
//         });
//       } else {
//         taskDropdown.innerHTML = `<option value="">No tasks found</option>`;
//       }
//     })
//     .catch((error) => console.error("Task Types API Error:", error));
// }
function formTaskTypes(session_id) {
    const url = `https://phpstack-1418759-5351611.cloudwaysapps.com/api/task/types/${session_id}`;
    const taskDropdown = document.getElementById("62460-select-2");
    const ramenOptionsContainer = document.getElementById("ramen-options");
    const ramenLabel = document.getElementById("ramen-label");

    fetch(url)
        .then((response) => response.json())
        .then((data) => {
            // Reset select + label + opties
            taskDropdown.innerHTML = `<option value="">Selecteer aantal ramen</option>`;
            if (ramenOptionsContainer) {
                ramenOptionsContainer.innerHTML = "";
            }
            if (ramenLabel) {
                ramenLabel.textContent = "Selecteer aantal ramen";
            }

            if (data.data.taskTypes && data.data.taskTypes.length > 0) {
                data.data.taskTypes.forEach((task) => {
                    const taskName = task.name?.trim();

                    // Skip "Montage" of lege waarden
                    if (!taskName || taskName.includes("Montage")) return;

                    // 1) Optie in hidden <select>
                    const option = document.createElement("option");
                    option.value = task._id;
                    option.classList.add("tasks_list");
                    option.textContent = taskName;
                    taskDropdown.appendChild(option);
                });

                // 2) Opties verwijderen o.b.v. specifics_window_number (zoals je al deed)
                const remove_options = window.specifics_window_number
                    .split(',')
                    .map(item => item.trim());

                Array.from(taskDropdown.options).forEach(option => {
                    if (remove_options.includes(option.text.trim())) {
                        option.remove();
                    }
                });

                // 3) Build UI options in ramen-panel (like interests dropdown)
                if (ramenOptionsContainer) {
                    ramenOptionsContainer.innerHTML = ""; // clear existing

                    Array.from(taskDropdown.options).forEach(option => {
                        if (!option.value) return; // skip placeholder

                        // <label> wrapper like interests
                        const label = document.createElement("label");
                        label.className = "ramen-option-label";

                        // input type="radio" → single select
                        const input = document.createElement("input");
                        input.type = "radio";
                        input.className = "ramen-option";
                        input.name = "ramen_count";            // all radios share the same name
                        input.value = option.value;

                        // span with text
                        const span = document.createElement("span");
                        span.textContent = option.textContent;

                        // build structure
                        label.appendChild(input);
                        label.appendChild(span);

                        // click / change handler
                        input.addEventListener("change", () => {
                            // update hidden select
                            taskDropdown.value = option.value;

                            // update label text in the button
                            if (ramenLabel) {
                                ramenLabel.textContent = option.textContent;
                            }

                            // close panel
                            const ramenPanel = document.getElementById("ramen-panel");
                            if (ramenPanel) {
                                ramenPanel.classList.add("hidden");
                            }

                            // trigger change event for validation
                            const evt = new Event("change", { bubbles: true });
                            taskDropdown.dispatchEvent(evt);
                        });

                        ramenOptionsContainer.appendChild(label);
                    });
                }

            } else {
                taskDropdown.innerHTML = `<option value="">No tasks found</option>`;
                if (ramenOptionsContainer) {
                    ramenOptionsContainer.innerHTML =
                        `<div class="px-3 py-2 text-sm text-gray-500">Geen opties beschikbaar</div>`;
                }
            }
        })
        .catch((error) => console.error("Task Types API Error:", error));
}

document.addEventListener('DOMContentLoaded', function () {
    const ramenToggle = document.getElementById('ramen-toggle');
    const ramenPanel  = document.getElementById('ramen-panel');
    const ramenWrapper = document.getElementById('ramen-dropdown');

    if (!ramenToggle || !ramenPanel || !ramenWrapper) return;

    // Open/close dropdown
    ramenToggle.addEventListener('click', function () {
        ramenPanel.classList.toggle('hidden');
    });

    // Close when clicking outside
    document.addEventListener('click', function (e) {
        if (!ramenWrapper.contains(e.target)) {
            ramenPanel.classList.add('hidden');
        }
    });
});

document.getElementById("62460-select-2")
    .addEventListener("change", function () {
        const options = this.options;

        for (let i = 0; i < options.length; i++) {
            if (options[i].selected) {
                options[i].setAttribute("selected", "selected");
            } else {
                options[i].removeAttribute("selected");
            }
        }
    });
document.addEventListener("DOMContentLoaded", function () {
    const interestsPanel = document.getElementById("interests-panel");
    if (!interestsPanel) return;

    // Event delegation voor alle .interest-option checkboxes
    interestsPanel.addEventListener("change", function (event) {
        if (event.target.matches(".interest-option")) {
            const checkbox = event.target;

            if (checkbox.checked) {
                checkbox.setAttribute("checked", "checked");
                console.log(`${checkbox.value} is checked.`);
            } else {
                checkbox.removeAttribute("checked");
                console.log(`${checkbox.value} is unchecked.`);
            }
        }
    });
});
function validateAndCollectAddressData() {
    const form = document.getElementById("address_form");
    const data = {};
    let isValid = true;

    // 1. Clear old errors + remove old valid states
    form.querySelectorAll(".error-message").forEach(el => el.remove());
    form.querySelectorAll(".form-group").forEach(group =>
        group.classList.remove("valid")
    );

    // 2. Loop door alle inputvelden
    form.querySelectorAll("input").forEach((input) => {
        const name = input.name;
        const value = input.value.trim();
        const parentGroup = input.closest(".form-group");
        let fieldValid = true;

        // Skip disabled, but include the data
        if (input.disabled) {
            data[name] = value;
            return;
        }

        // POSTCODE
        if (name === "postalCode" && value !== "") {
            const nlPostcode = /^[0-9]{4}\s?[A-Za-z]{2}$/;
            if (!nlPostcode.test(value)) {
                fieldValid = false;
                isValid = false;

                const error = document.createElement("div");
                error.className = "error-message text-danger small mt-1";
                error.textContent = "Voer een geldige postcode in (bijv. 1234 AB).";
                parentGroup.appendChild(error);
                parentGroup.parentElement.classList.add("invalid");
            }
        }

        // REQUIRED FIELDS
        if (input.hasAttribute("required") && value === "") {
            fieldValid = false;
            isValid = false;

            const error = document.createElement("div");
            error.className = "error-message text-danger small mt-1";
            error.textContent = "Dit veld is verplicht.";
            parentGroup.appendChild(error);
            parentGroup.parentElement.classList.add("invalid");
        }

        // 3. Als veld geldig is → vinkje tonen
        if (fieldValid && value !== "") {
            parentGroup.classList.add("valid");
        }

        data[name] = value;
    });

    return isValid ? data : null;
}
// === Live validation to remove error messages as the user types ===
document.querySelectorAll("#address_form input").forEach((input) => {
    input.addEventListener("input", () => {
        if (input.value.trim() !== "") {
            const error = input.parentElement.querySelector(".error-message");
            if (error) error.remove();
        }
    });
});

pick_time.addEventListener("click", function () {
    const addressData = validateAndCollectAddressData();
    console.log(addressData, 'ad');

    if (addressData) {
        // ✅ Push static event to DataLayer for GTM
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "button_click_request_timeslot",
            button_name: "start_request_timeslot",
        });
        console.log("Address form is valid:", addressData);

        // Hide the address form and show the suggestions div
        address_form.classList.add("hidden");
        suggestionsDiv.classList.remove("hidden");
        Opties_berekenen.classList.remove("hidden");

        setTimeout(() => {
            scrollElementToTop(suggestionsDiv);
        }, 50);

        // Get the session ID and task type ID
        const session_id = localStorage.getItem("sessionID");
        const taskTypeId = taskDropdown.value;
        console.log("Selected value:", taskTypeId);

        // Gather address form data
        const address_form_data = document.getElementById("address_form");
        const addressform = {};
        const formElements = address_form_data.elements;
        for (let element of formElements) {
            if (element.type !== "button" && element.type !== "submit") {
                addressform[element.name] = element.value;
            }
        }
        console.log("address_form", addressform);

        // Gather client form data
        const client_form_data = document.getElementById("confirmation_form_div");
        const client_form = {};
        const clientformElements = client_form_data.elements;
        for (let element of clientformElements) {
            if (element.type === "text" || element.type === "email" || element.type === "tel") {
                if (element.name) {
                    client_form[element.name] = element.value;
                }
            }
        }
        console.log("client_form", client_form);

        const tags_value = Array.from(
            document.querySelectorAll('.interest-option:checked')
        ).map((checkbox) => checkbox.value);

        // Call the createTaskId function with the necessary data
        createTaskId(client_form, addressform, taskTypeId, tags_value, session_id);
    } else {
        console.log("Address form is invalid.");
    }
});

function scrollElementToTop(el) {
    if (!el) return;

    const rect = el.getBoundingClientRect();
    const absoluteTop = rect.top + window.pageYOffset;

    window.scrollTo({
        top: absoluteTop,
    });
}

function createTaskId(  client_form,  addressform,  taskTypeId,  tags_value,  session_id) {
    console.log("Session ID:", session_id);
    console.log("Task Type ID:", taskTypeId);
    console.log("Client Form Data:", client_form);
    console.log("Address Form Data:", addressform);
    console.log("Tags Value:", tags_value);

    const url = `https://phpstack-1418759-5351611.cloudwaysapps.com/api/task/create?session_id=${session_id}`;

// Capture GCLID
    const gclid = getGclid();
    const payload = {
        client: {
            firstName: client_form?.firstName || "",
            lastName: client_form?.lastName || "",
            emailAddress: client_form?.emailAddress || "",
            phoneNumber: client_form?.phoneNumber || "",
        },
        location: {
            street: addressform?.street || "",
            streetNumber: addressform?.streetNumber || "",
            streetNumberSuffix: addressform?.streetNumberSuffix || "",
            postalCode: addressform?.postalCode || "",
            place: addressform?.city || "",
            country: "NL",
        },
        task: {
            taskTypeId: taskTypeId || "",
            status: "open",
            description: tags_value?.join(", ") || "", // joins selected tags (interests) into a string,
            gclid:gclid
        },
    };

    fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
        })
        .then((data) => {
            console.log("createTaskId API Response:", data);

            const taskId = data?.data?.taskId;
            if (taskId) {
                localStorage.setItem("task_ID", taskId);
                console.log("Created Task ID:", taskId);
                reqSuggestion(taskId, session_id);
            } else {
                console.warn("Task ID not found in response.");
            }
            const clientId = data?.data?.clientId;
            if (clientId) {
                localStorage.setItem("clientID", clientId);
                console.log("Created Client ID:", clientId);
            } else {
                console.warn("Client ID not found in response.");
            }
        })
        .catch((error) => {
            console.error("API Error:", error);
        });
}

// get suggestions for // request suggestions
function reqSuggestion(task_id, sess_id, timeSlotRequest) {
    console.log("reqSuggestion Task ID:", task_id);
    console.log("reqSuggestion Session ID:", sess_id);

    const url = `https://phpstack-1418759-5351611.cloudwaysapps.com/api/request/suggestion`;
    fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            taskId: task_id,
            session_id: sess_id,
            requestedTimeslots:timeSlotRequest,
        }),
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
        })
        .then((data) => {
            const Request_Id = data.data.suggestionId;
            // console.log("Request_Id",Request_Id)
            const session_id = localStorage.getItem("sessionID");

            setTimeout(() => {
                suggestionGet(task_id, sess_id);
            }, 2000);
        })
        .catch((error) => console.error("API Error:", error));
}
function suggestionGet(  Request_Id,  session_id,  containerClass = "timeslot-container") {
    console.log("suggestion Task ID:", Request_Id);
    console.log("suggestion Session ID:", session_id);

    // After timeslots are rendered: scroll suggestions block to top of viewport
    setTimeout(() => {
        scrollElementToTop(suggestionsDiv);
    }, 50);

    const url = `https://phpstack-1418759-5351611.cloudwaysapps.com/api/get/suggestion/${session_id}?taskId=${Request_Id}`;
    console.log(url);

    // Show Opties_berekenen before API call
    Opties_berekenen.classList.remove("hidden");

    fetch(url)
        .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
        })
        .then((data) => {
            // Hide Opties_berekenen after data is received
            Opties_berekenen.classList.add("hidden");

            console.log(" suggestionGet Full API Response:", data);

            if (!data.data || !data.data.suggestion || !Array.isArray(data.data.suggestion.timeslots)) {
                console.error("Invalid response structure:", data);

                if (ENABLE_CUSTOM_DATE) {
                    suggestionsDiv.classList.add("hidden");
                    custom_date.classList.remove("hidden");

                    setTimeout(() => {
                        scrollElementToTop(custom_date);
                    }, 50);
                } else {
                    suggestionsDiv.classList.remove("hidden");

                    if (invalid) {
                        invalid.classList.remove("hidden");
                        invalid.innerHTML = `
<div class=" p-6 space-y-4">

    <p class="font-semibold text-red-600">
        Er is op dit moment geen moment beschikbaar
    </p>

    <p>
        Geen probleem. Je kunt direct gebruikmaken van onze online meethulp en alsnog advies op maat ontvangen, zonder afspraak aan huis.
    </p>

    <a
        href="https://www.solerza.nl/pages/online-meethulp"
        target="_blank"
        class="inline-flex justify-center items-center btn btn--primary w-full mt-2"
    >
        <span class="btn__text">Bekijk de online meethulp</span>
    </a>

</div>
                        `;
                    }

                    if (showCalendarBtn) {
                        showCalendarBtn.classList.add("hidden");
                        infoBlock.classList.add("hidden");
                        timeslotHint.classList.add("hidden");
                    }
                }

                return;
            }

            suggestionsDiv.classList.remove("hidden");

            const timeslots = [...data.data.suggestion.timeslots].sort((a, b) => {
                const aIsGreen = !!a.greenChoice;
                const bIsGreen = !!b.greenChoice;

                if (aIsGreen && !bIsGreen) return -1;
                if (!aIsGreen && bIsGreen) return 1;

                // 🔥 2. Daarna sorteren op datum
                const aDate = new Date(a?.etaRange?.from?.date || 0).getTime();
                const bDate = new Date(b?.etaRange?.from?.date || 0).getTime();

                return aDate - bDate;
            });

            const containers = document.querySelectorAll(`.${containerClass}`);

            if (timeslots.length > 0 && containers.length > 0) {

                containers.forEach((container) => {
                    container.innerHTML = "";

                    timeslots.forEach((slot) => {
                        if (!slot.etaRange || !slot.etaRange.from || !slot.etaRange.to)
                            return;

                        let plannedDate = '';
                        let fromTime = '';
                        let toTime = '';

                        if (slot?.etaRange?.from?.date && slot?.etaRange?.to?.date) {

                            const fromDateObj = new Date(slot.etaRange.from.date);
                            const toDateObj = new Date(slot.etaRange.to.date);

                            // Format: Woensdag 4 maart
                            plannedDate = fromDateObj.toLocaleDateString('nl-NL', {
                                weekday: 'long',
                                day: 'numeric',
                                month: 'long'
                            });

                            // Hoofdletter eerste letter
                            plannedDate =
                                plannedDate.charAt(0).toUpperCase() + plannedDate.slice(1);

                            fromTime = fromDateObj.toLocaleTimeString('nl-NL', {
                                hour: '2-digit',
                                minute: '2-digit'
                            });

                            toTime = toDateObj.toLocaleTimeString('nl-NL', {
                                hour: '2-digit',
                                minute: '2-digit'
                            });

                        } else {
                            // fallback (veiligheid)
                            plannedDate = slot.etaRange.from.plannedDateCalendar
                                ?.split("|")[0]
                                ?.trim() || '';

                            fromTime = slot.etaRange.from.plannedDateTime || '';
                            toTime = slot.etaRange.to.plannedDateTime || '';
                        }

                        const slotId = slot._id;

                        const button = document.createElement("button");
                        button.className = "btn btn-timeslot btn-optimal-date-timeslot";
                        button.setAttribute("title", `Selecteer tijd: ${slot.etaRange.from.plannedDateLong}`);
                        button.setAttribute("data-id", slotId);
                        button.setAttribute("data-date", plannedDate);
                        button.setAttribute(
                            "data-time_slot_suggestion_json",
                            JSON.stringify(slot)
                        );

                        // ⬇️ Check of dit een greenChoice slot is
                        const isGreenChoice = !!slot.greenChoice;

                        if (isGreenChoice) {
                            button.classList.add("green-choice");

                            button.innerHTML = `
                            <div class="text-lg font-semibold">${plannedDate}</div>
                    
                            <div class="padtxxs text-base">
                                Tussen ${fromTime} - ${toTime}
                            </div>
                               <div class="green-choice-badge flex items-center gap-2 mb-2">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     fill="currentColor"
                                     viewBox="0 0 24 24"
                                     class="w-4 h-4">
                                    <path d="M5 21c0-7.732 6.268-14 14-14h2c-1.5 9-8 14-16 14z"></path>
                                </svg>
                                Groene keuze
                            </div>
                        `;
                        }else {
                            button.innerHTML = `
                            <div class="text-lg font-semibold">${plannedDate}</div>
                            <div class="padtxxs text-base">Tussen ${fromTime} - ${toTime}</div>
                        `;
                        }
                        const firstGreen = containers[0]?.querySelector(".green-choice");
                        if (firstGreen) {
                            firstGreen.classList.add("ring-2", "ring-green-500");
                        }
                        container.appendChild(button);
                    });
                });

                const renderedAnySlot = containers[0]?.querySelector(".btn-timeslot");

                if (renderedAnySlot && showCalendarBtn && showCalendarBtnAfterLoad && Get_more_suggestions > 1) {
                    if (ENABLE_CUSTOM_DATE) {
                        showCalendarBtn.hidden = true;
                        showCalendarBtnAfterLoad.hidden = false;
                    } else {
                        showCalendarBtn.hidden = false;
                        showCalendarBtnAfterLoad.hidden = true;
                    }
                }

                // After timeslots are rendered: scroll suggestions block to top of viewport
                setTimeout(() => {
                    scrollElementToTop(suggestionsDiv);
                }, 50);
            } else {
                console.warn("No valid timeslots found or no containers present.");
            }
        })
        .catch((error) => {
            Opties_berekenen.classList.add("hidden");
            console.error("Suggestion API Error:", error);
        });
}

// // Select all buttons inside the timeslot container

document.addEventListener("DOMContentLoaded", () => {
    const timeslotContainers = document.querySelectorAll(".timeslot-container");
    const confirm_appointment = document.querySelector(".confirm_appointment");
    const confirm_btn_no = document.querySelector(".confirm_btn_no");
    const confirm_btn = document.querySelector(".confirm_btn");
    const selectslot_option = document.querySelector(".selectslot_option");
    const selectslot_time = document.querySelector(".selectslot_time");
    confirm_btn_no.addEventListener("click", () => {
        confirm_appointment.classList.add("hidden");


    })

    timeslotContainers.forEach((container) => {
        container.addEventListener("click", (event) => {
            const button = event.target.closest("button");
            if (!button) return;

            // ✅ Push static event to DataLayer for GTM
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "button_click_proposal",
                button_name: "submit_text_proposal",
            });

            // Show the confirmation UI
            confirm_appointment.classList.remove("hidden");

            // confirm_appointment.scrollIntoView({
            //     behavior: "smooth",
            //     block: "start"
            // });

            // Optional: You might want to store selected timeSlotId in a variable for use on confirm_btn click
            const timeSlotId = button.getAttribute("data-id");
            const timeSlotdate = button.getAttribute("data-date");
            const timeSlottime = button.querySelector(".padtxxs")?.innerHTML || "";

            const timeSlotJson = button.getAttribute("data-time_slot_suggestion_json");
            if (timeSlotJson) {
                selectedCalendarSlot = JSON.parse(timeSlotJson);
            }

            selectslot_time.innerHTML = timeSlottime;
            selectslot_option.innerHTML = timeSlotdate;
            if (!timeSlotId) return console.error("Time slot ID not found!");

            const sessionId = localStorage.getItem("sessionID");
            if (!sessionId) return console.error("Session ID not found!");

            // Prepare confirm_btn logic
            confirm_btn.onclick = () => {
                confirm_appointment.classList.add("hidden");
                loader.classList.remove('hidden');
                // booking_form.parentElement.classList.add('sticky');
                if (formBeforeDateSelection) {
                    formBeforeDateSelection.classList.add("hidden");
                }
                suggestionsDiv.classList.add("hidden");
                back_btn.classList.add("hidden");
                if (steps) {
                    steps.classList.add("hidden");
                }
                // document.querySelector('.booking-form').scrollIntoView({
                //     behavior: 'smooth',
                //     block: 'start'
                // });
                setTimeout(() => {
                    pickTimeSlot(sessionId, timeSlotId, button)
                        .then((response) => console.log("TimeSlot picked API Response:", response))
                        .catch((error) => console.error("Failed to pick time slot:", error));
                }, 100);
            };
        });
    });
});


// Function to send the API request and render all summaries
async function pickTimeSlot(sessionId, timeSlotId, button) {
    const apiUrl = "https://phpstack-1418759-5351611.cloudwaysapps.com/api/pick/timeslot";
    const requestData = {
        session_id: sessionId,
        time_slotID: timeSlotId,
    };

    try {
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(requestData),
        });

        // --- 1. Client Summary ---
        const form_summary = document.getElementById("form-summary");
        form_summary.classList.remove("hidden");
        const summaryList = document.getElementById("summary-list");
        summaryList.innerHTML = "";

        const form = document.getElementById("confirmation_form_div");
        const formData = new FormData(form);
        const firstName = formData.get("firstName") || "";
        const lastName = formData.get("lastName") || "";
        const email = formData.get("emailAddress") || "";
        const phone = formData.get("phoneNumber") || "";

        const ramenSelect = document.getElementById("62460-select-2");
        const ramenText = ramenSelect.options[ramenSelect.selectedIndex]?.text || "";
        const checkedInterests = Array.from(
            document.querySelectorAll('.interest-option:checked')
        ).map(cb => cb.value);

        const clientItems = [
            { label: "Naam", value: `${firstName} ${lastName}`.trim() },
            { label: "E-mail", value: email },
            { label: "Telefoon", value: phone },
            // { label: "Aantal ramen", value: ramenText },
            // { label: "Interesses", value: checkedInterests.join(", ") },
        ];

        clientItems.forEach(item => {
            const li = document.createElement("li");
            li.innerHTML = `<strong>${item.label}:</strong> ${item.value}`;
            summaryList.appendChild(li);
        });

        // --- 2. Address Summary ---
        const addressList = document.getElementById("address-list");
        addressList.innerHTML = "";

        const addressForm = document.getElementById("address_form");
        const addressData = new FormData(addressForm);

        const street = addressData.get("street") || "";
        const street_no = addressData.get("streetNumber") || "";
        const postalCode = addressData.get("postalCode") || "";
        const place = addressData.get("city") || "";
        const fullAddress = `${street}`;
        const trimmedAddress = fullAddress.split("Nederland")[0] + "Nederland";
        console.log(trimmedAddress);
        // const fullAddress = `${street} ${street_no}, ${postalCode} ${place}`;
        const streetSuffix = addressData.get("streetNumberSuffix") || "";

        const fullAddressCustom = `${street} ${street_no}${streetSuffix ? streetSuffix : ""}`;
        console.log(fullAddressCustom);

        const addressItems = [
            { label: "", value: street_no },
            { label: "", value: street },
            { label: "", value: postalCode },
            { label: "", value: place },
        ];

        const fullAddress1 = `${street} ${street_no}, ${postalCode} ${place}`;

        const li = document.createElement("li");
        li.textContent = fullAddress1;    // or li.innerHTML if you need formatting
        addressList.appendChild(li);

        // --- 3. Time Slot Summary ---
        let bookingDate = "";
        const timeSlotJson = button.getAttribute("data-time_slot_suggestion_json");
        if (timeSlotJson) {
            const parsed = JSON.parse(timeSlotJson);
            const fromTime = new Date(parsed.etaRange.from.date);
            const toTime = new Date(parsed.etaRange.to.date);

            bookingDate = fromTime.toISOString().split("T")[0]; // Format for customer creation

            const dateString = fromTime.toLocaleDateString("nl-NL", {
                weekday: "long", year: "numeric", month: "long", day: "numeric"
            });

            const fromFormatted = fromTime.toLocaleTimeString("nl-NL", { hour: "2-digit", minute: "2-digit" });
            const toFormatted = toTime.toLocaleTimeString("nl-NL", { hour: "2-digit", minute: "2-digit" });
            // const duration = Math.round((toTime - fromTime) / 60000);

            const timeslotList = document.getElementById("timeslot-list");

            if (timeslotList) {
                timeslotList.innerHTML = "";

                const li = document.createElement("li");
                li.innerHTML = `<strong>${dateString}, Tussen ${fromFormatted} - ${toFormatted}</strong>`;

                timeslotList.appendChild(li);
            }
        }

        // --- Call createCustomer ---
        const description = checkedInterests.join(", ");
        const type = ramenText;

        createCustomer(firstName, lastName, email, fullAddressCustom, postalCode, bookingDate, description, type, phone, place);

        // --- Destroy Session ---
        loader.classList.add('hidden');
        setTimeout(function () {
            destroySession(sessionId);
            // setTimeout(() => {
            booking_form.parentElement.classList.remove('sticky');
            // }, 50);
        },500);

        // --- Show Summary ---
        const confirmation_summary_div = document.getElementById("confirmation_summary_div");
        confirmation_summary_div.classList.remove("hidden");
        // confirmation_summary_div.scrollIntoView({
        //     behavior: "smooth",
        //     block: "start"
        // });
        booked_opponent.classList.remove("hidden");
        const addToCalendarBtn = document.getElementById("add-to-calendar-btn");

        if (selectedCalendarSlot) {
            addToCalendarBtn?.classList.remove("hidden");
        } else {
            addToCalendarBtn?.classList.add("hidden");
        }

        fireConfetti();
        return await response.json();
    } catch (error) {
        console.error("Error:", error);
        throw error;
    }
}

// --- Create Customer ---
function createCustomer(firstName, lastName, email, address, postalCode, date, description, type, phone,place) {
    // console.log("firstName",firstName)
    // console.log("lastName",lastName)
    // console.log("email",email)
    // console.log("address",address)
    // console.log("postalCode",postalCode)
    // console.log("date",date)
    // console.log("description",description)
    // console.log("type",type)
    // console.log("phone",phone)
    const apiUrl = "https://phpstack-1418759-5351611.cloudwaysapps.com/api/create/customer";

    const gclid = getGclid();
    const requestData = {
        first_name: firstName,
        last_name: lastName,
        email_address: email,
        address: address,
        zip_code: postalCode,
        date: date,
        description: description,
        type: type,
        phone: phone,
        gclid:gclid,
        place: place
    };

    return fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
    })
        .then((response) => {
            if (!response.ok) throw new Error("Failed to create customer");
            // return response.json();
        })
        .then((data) => {
            console.log("Customer created:", data);
        })
        .catch((error) => {
            console.error("Error creating customer:", error);
        });
}

// --------------------------------------
// GCLID read helpers (booking form only)
// --------------------------------------
const GCLID_KEY = "gclid";

function getGclidFromStorage() {
    // 1) localStorage
    try {
        const lsValue = localStorage.getItem(GCLID_KEY);
        if (lsValue) return lsValue;
    } catch (e) {
        console.warn("Could not read gclid from localStorage", e);
    }

    // 2) sessionStorage
    try {
        const ssValue = sessionStorage.getItem(GCLID_KEY);
        if (ssValue) return ssValue;
    } catch (e) {
        console.warn("Could not read gclid from sessionStorage", e);
    }

    // 3) cookie
    try {
        const match = document.cookie.match(new RegExp("(^|; )" + GCLID_KEY + "=([^;]*)"));
        if (match) return decodeURIComponent(match[2]);
    } catch (e) {
        console.warn("Could not read gclid cookie", e);
    }

    return null;
}

/**
 * Booking-form getter:
 * - assumes gclid-sitewide.js already captured & stored it earlier
 */
function getGclid() {
    return getGclidFromStorage();
}

// --- Destroy Session ---
function destroySession(sessionId) {
    const destroyUrl = `https://phpstack-1418759-5351611.cloudwaysapps.com/api/destroy/session/${sessionId}`;
    return fetch(destroyUrl)
        .then(response => {
            if (!response.ok) throw new Error("Failed to destroy session");
            console.log("Session destroyed");
        })
        .catch(error => {
            console.error("Error destroying session:", error);
        });
}



// loction suggestions
const straatInput = document.getElementById("straat");
const suggestionBox = document.getElementById("straat-suggestions");
let debounceTimeout;

straatInput.addEventListener("input", () => {
    clearTimeout(debounceTimeout);

    const input = straatInput.value.trim();
    console.log("address", input);

    if (input.length <= 3) {
        suggestionBox.innerHTML = "";
        suggestionBox.classList.remove("visible");
        return;
    }

    debounceTimeout = setTimeout(() => {
        fetchAddressSuggestions(input);
    }, 300); // Delay to prevent rapid API calls
});

async function fetchAddressSuggestions(input) {
    suggestionBox.innerHTML = "";
    suggestionBox.classList.add("visible");

    try {
        const response = await fetch(
            "https://phpstack-1418759-5351611.cloudwaysapps.com/api/address/suggestion",
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ input }),
            }
        );

        const result = await response.json();
        const predictions = result.predictions || [];

        if (predictions.length === 0) {
            suggestionBox.innerHTML =
                '<li style="padding: 5px 10px; color: red;">Geen suggestie gevonden</li>';
            return;
        }

        console.log("Straat Location", predictions);

        predictions.forEach((prediction) => {
            const li = document.createElement("li");
            li.textContent = prediction.description;
            li.setAttribute("data-location-id", prediction.place_id);

            li.addEventListener("click", () => {
                straatInput.value = prediction.description;
                suggestionBox.innerHTML = "";
                suggestionBox.classList.remove("visible");

                const location = prediction.description;
                const locationId = li.getAttribute("data-location-id");
                fetchPlaceDetails(locationId, location);
            });

            suggestionBox.appendChild(li);
        });
    } catch (error) {
        console.error("Error fetching suggestions:", error);
        suggestionBox.innerHTML =
            '<li style="padding: 5px 10px; color: red;">Error fetching suggestions</li>';
    }
}



function checkAndFetchAddress() {
    const streetValue = new_street.value.trim();
    const postcodeValue = new_postcode.value.trim();
    const cityValue = new_city.value.trim();

    // Call API only if street is not empty AND postcode has minimum 4 characters
    if (streetValue !== "" && postcodeValue.length >= 4) {
        const userInput = `${streetValue} ${postcodeValue} ${cityValue}`;
        console.log("Calling fetchAddresslookup with:", userInput);
        fetchAddresslookup(postcodeValue,streetValue);
    }
}

async function fetchAddressLookup(sessionId, postalCode, streetNumber) {
    try {

        // Build URL with GET parameters
        const url = new URL(
            "https://phpstack-1418759-5351611.cloudwaysapps.com/api/address/lookup"
        );

        url.searchParams.append("postalCode", postalCode);
        url.searchParams.append("streetNumber", streetNumber);
        url.searchParams.append("session_id", sessionId);

        console.log("🔍 Fetching lookup from:", url.toString());

        const response = await fetch(url.toString(), {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        });

        const result = await response.json();

        console.group("📬 Address Lookup Debug (GET)");
        console.log("Request:", { postalCode, streetNumber, sessionId });
        console.log("Response:", result);
        console.groupEnd();

        if (!result.status) {
            console.error("Lookup failed:", result.error || result.message);
            return;
        }

        const data = result.data || {};

        // Street
        const streetField = document.getElementById("straat");
        if (streetField) {
            streetField.value = data.street || "";
            streetField.parentElement.hidden = false;
        }

        // City
        const cityField = document.getElementById("city");
        if (cityField) {
            cityField.value = data.city || data.place || "";
            cityField.parentElement.hidden = false;
        }

        // Province
        const provinceField = document.getElementById("plaats");
        if (provinceField) {
            provinceField.value = data.province || data.state || "";
            provinceField.parentElement.hidden = false;
        }

        // Postal Code (normalized)
        const postalField = document.getElementById("Postcode");
        if (postalField && data.postalCode) {
            postalField.value = data.postalCode;
        }

        // Unhide the container with house number + suffix fields
        const streetNumberContainer = document.querySelector("#address_form .custom-fg");
        if (streetNumberContainer) {
            streetNumberContainer.hidden = false;
        }

    } catch (error) {
        console.error("❌ Error fetching address:", error);
    }
}


// // Listen for changes on street field
// new_street.addEventListener("input", checkAndFetchAddress);
//
// // Listen for changes on postcode field
// new_postcode.addEventListener("input", checkAndFetchAddress);
//
// new_postcode.addEventListener("input", checkAndFetchAddress);
//
// // Listen for changes on city field
// new_city.addEventListener("input", checkAndFetchAddress);


// Hide suggestions on outside click
// document.addEventListener("click", (e) => {
//     if (!suggestionBox.contains(e.target) && e.target !== straatInput) {
//         suggestionBox.innerHTML = "";
//     }
// });
async function fetchPlaceDetails(placeId, location) {
    try {
        const response = await fetch(
            "https://phpstack-1418759-5351611.cloudwaysapps.com/api/get/details",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ place_id: placeId }),
            }
        );

        const result = await response.json();
        console.log("Details API Response:", result);

        const postCode = result.zipcode || "";
        const streetNumberRaw = (result.street_number || "").toString(); // e.g. "70a" or "70"
        const city = result.city || "";

        // Try to get street from API, otherwise derive it from the first line of the suggestion
        const primaryLine = typeof location === "string"
            ? location.split(",")[0].trim()      // "Kuiperstraat 70a"
            : "";

        let street = (result.street || "").trim();
        if (!street && primaryLine) {
            // Remove everything from the first digit onwards: "Kuiperstraat 70a" → "Kuiperstraat"
            street = primaryLine.replace(/\d.*$/, "").trim();
        }

        let houseNumber = "";
        let suffix = "";

        // 1) Try to split backend street_number: "70a" → "70" + "a"
        if (streetNumberRaw) {
            const m = streetNumberRaw.match(/^(\d+)\s*([a-zA-Z]{0,3})?$/);
            if (m) {
                houseNumber = m[1];       // "70"
                suffix = m[2] || "";      // "a"
            } else {
                houseNumber = streetNumberRaw;
            }
        }
        // 2) Fallback: parse from the primary line if needed
        else if (primaryLine) {
            const m2 = primaryLine.match(/^(.+?)\s+(\d+)\s*([a-zA-Z]{0,3})?$/);
            if (m2) {
                street = m2[1].trim();
                houseNumber = m2[2];
                suffix = m2[3] || "";
            }
        }

        // --- Fill form fields ---
        const streetInput = document.getElementById("straat");
        if (streetInput) streetInput.value = street;

        const pcInput = document.getElementById("Postcode");
        if (pcInput) pcInput.value = postCode;

        const cityInput = document.getElementById("city");
        if (cityInput) cityInput.value = city;

        const numberInput = document.getElementById("straatnummer");
        if (numberInput) numberInput.value = houseNumber;

        // Try multiple possible IDs for suffix
        const suffixInput =
            document.getElementById("streetNumberSuffix") ||
            document.getElementById("straatnummertoevoeging") ||
            document.getElementById("toevoeging");

        if (suffixInput) suffixInput.value = suffix;

        const provinceInput = document.getElementById("plaats");
        if (provinceInput) {
            provinceInput.value = result.state || result.city || "";
        }

        validateAndCollectAddressData()
        showAddressFields();

    } catch (error) {
        console.error("Error fetching place details:", error);
    }
}
function showAddressFields() {
    document
        .querySelectorAll("#address_form [hidden]")
        .forEach(el => el.hidden = false);
}
async function cancelSuggesstion(sessionId, task_id, select_time, timeSlotRequest) {
    console.log("cancelSuggesstion sessionId:", sessionId);
    console.log("cancelSuggesstion select_time:", select_time);
    console.log("cancelSuggesstion task_id:", task_id);
    console.log("cancelSuggesstion timeSlotRequest:", timeSlotRequest);

    const data = {
        taskId: task_id,
        session_id: sessionId,
    };

    try {
        const response = await fetch("https://phpstack-1418759-5351611.cloudwaysapps.com/api/cancel/suggestion", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });

        const result = await response.json();

        if (!response.ok) {
            throw new Error(result.message || "Fout bij bijwerken van taak.");
        }
        if (select_time !== null) {
            updateTask(sessionId, select_time, task_id);
            console.log("Call api updateTask");
        } else if (timeSlotRequest !== null) {
            reqSuggestion(task_id, sessionId, timeSlotRequest);
            console.log("Call api reqSuggestion");
        } else {
            console.log("Call api cancelSuggesstion");
        }


    } catch (error) {
        console.error("API Fout:", error);
    }
}


async function updateTask(sessionId, select_time, task_id) {
    console.log("updateTask sessionId",sessionId)
    console.log("updateTask select_time",select_time)
    console.log("updateTask task_id",task_id)
    const data = {
        taskId: task_id,
        session_id: sessionId,
        tagIds :select_time,
    };

    try {
        const response = await fetch("https://phpstack-1418759-5351611.cloudwaysapps.com/api/update/task", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });

        const result = await response.json();

        if (!response.ok) {
            throw new Error(result.message || "Fout bij bijwerken van taak.");
        }
// reqSuggestion(task_id, sessionId);
        // If successful, continue with UI updates
        Get_more_suggestions = 1;
        invalid.innerHTML = "";


        // pick_time.click();
    } catch (error) {
        console.error("API Fout:", error);
        alert("Er is een fout opgetreden: " + error.message);
    }
}

//   suggestionsDiv.classList.add("hidden");
//   customRequest(sessionId, task_id, customerMsg, ownerId);
// });
const customDayInput = document.getElementById("custom_day");
const custom_date_text = document.querySelector(".custom_date_text");
const custom_request = document.querySelector(".custom_request");
// const custom_date_btn = document.querySelector(".custom_date_btn"); // you were missing this
// const suggestionsDiv = document.querySelector(".suggestions"); // assuming this exists

if (custom_date_btn && customDayInput) {
    custom_date_btn.addEventListener("click", function (e) {
        e.preventDefault();

        if (!validateCustomDateForm()) {
            return;
        }

        const customerMsg = customDayInput.value.trim();
        const selectedMoments = getSelectedPreferredMoments();

        const session_id = localStorage.getItem("sessionID");
        const taskId = localStorage.getItem("task_ID");
        const ownerId = localStorage.getItem("clientID");

        // Optional GTM event
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "button_click",
            button_name: "Plan mijn afspraak",
        });

        cancelSuggesstion(session_id, taskId, ["3Tr5M82E1"], null);
        customRequest(session_id, taskId, customerMsg, ownerId, selectedMoments);
    });
}

async function customRequest(sessionId, task_id, customerMsg, ownerId, preferredMoments = []) {
    const messageParts = [];
    selectedCalendarSlot = null;

    if (preferredMoments.length) {
        messageParts.push(`Voorkeursmomenten: ${preferredMoments.join(", ")}`);
    }

    if (customerMsg) {
        messageParts.push(`Toelichting: ${customerMsg}`);
    }

    const finalMessage = messageParts.join(" | ");

    const data = {
        taskId: task_id,
        ownerId: ownerId,
        subject: "request manual suggestion",
        session_id: sessionId,
        message: finalMessage,
    };

    console.log("You are here");

    try {
        const response = await fetch("https://phpstack-1418759-5351611.cloudwaysapps.com/api/task/note", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });

        const result = await response.json();

        if (!response.ok) {
            throw new Error(result.message || "Fout bij bijwerken van taak.");
        }

        const form = document.getElementById("confirmation_form_div");
        const formData = new FormData(form);
        const firstName = formData.get("firstName") || "";
        const lastName = formData.get("lastName") || "";
        const email = formData.get("emailAddress") || "";
        const phone = formData.get("phoneNumber") || "";

        const addressForm = document.getElementById("address_form");
        const addressData = new FormData(addressForm);

        const street = addressData.get("street") || "";
        const street_no = addressData.get("streetNumber") || "";
        const streetSuffix = addressData.get("streetNumberSuffix") || "";
        const postalCode = addressData.get("postalCode") || "";
        const place = addressData.get("city") || "";

        const fullAddressCustom = `${street} ${street_no}${streetSuffix ? streetSuffix : ""}`;

        const ramenSelect = document.getElementById("62460-select-2");
        const ramenText = ramenSelect?.options[ramenSelect.selectedIndex]?.text || "";

        const checkedInterests = Array.from(
            document.querySelectorAll(".interest-option:checked")
        ).map((cb) => cb.value);

        const bookingDate = "";

        const descriptionParts = [];

        if (checkedInterests.length) {
            descriptionParts.push(`Interesse: ${checkedInterests.join(", ")}`);
        }

        if (preferredMoments.length) {
            descriptionParts.push(`Voorkeursmomenten: ${preferredMoments.join(", ")}`);
        }

        if (customerMsg) {
            descriptionParts.push(`Toelichting: ${customerMsg}`);
        }

        const description = descriptionParts.join(" | ");

        await createCustomer(
            firstName,
            lastName,
            email,
            fullAddressCustom,
            postalCode,
            bookingDate,
            description,
            ramenText,
            phone,
            place
        );

        customerData(customerMsg, preferredMoments);

        const Tijdslot = document.querySelector(".Tijdslot ");
        booking_form.parentElement.classList.add("sticky");

        if (formBeforeDateSelection) {
            formBeforeDateSelection.classList.add("hidden");
        }

        suggestionsDiv.classList.add("hidden");
        Tijdslot.classList.add("hidden");
        back_btn.classList.add("hidden");

        if (steps) {
            steps.classList.add("hidden");
        }

        custom_date.classList.add("hidden");
        custom_request.classList.remove("hidden");

        const addToCalendarBtn = document.getElementById("add-to-calendar-btn");
        addToCalendarBtn?.classList.add("hidden");

        const confirmation_summary_div = document.getElementById("confirmation_summary_div");
        if (confirmation_summary_div) {
            confirmation_summary_div.classList.remove("hidden");
        }

        fireConfetti();
        console.log("Success:", result);

        setTimeout(() => {
            custom_date_text.innerHTML = finalMessage;
        }, 100);

    } catch (error) {
        console.error("API Fout:", error);
        alert("Er is een fout opgetreden: " + error.message);
    }
}

function customerData(customerMsg, preferredMoments = []) {
    const form_summary = document.getElementById("form-summary");
    form_summary.classList.remove("hidden");

    const title = document.querySelector(".booking-confirmation-title");
    if (title) {
        title.innerHTML = "Je afspraak is succesvol ingepland!";
    }

    const summaryList = document.getElementById("summary-list");
    summaryList.innerHTML = "";

    const form = document.getElementById("confirmation_form_div");
    const formData = new FormData(form);
    const firstName = formData.get("firstName") || "";
    const lastName = formData.get("lastName") || "";
    const email = formData.get("emailAddress") || "";
    const phone = formData.get("phoneNumber") || "";

    const clientItems = [
        { label: "Naam", value: `${firstName} ${lastName}`.trim() },
        { label: "E-mail", value: email },
        { label: "Telefoon", value: phone },
    ];

    if (preferredMoments.length) {
        clientItems.push({
            label: "Voorkeursmomenten",
            value: preferredMoments.join(", "),
        });
    }

    if (customerMsg) {
        clientItems.push({
            label: "Toelichting",
            value: customerMsg,
        });
    }

    clientItems.forEach((item) => {
        const li = document.createElement("li");
        li.innerHTML = `<strong>${item.label}:</strong> ${item.value}`;
        summaryList.appendChild(li);
    });

    const addressList = document.getElementById("address-list");
    addressList.innerHTML = "";

    const addressForm = document.getElementById("address_form");
    const addressData = new FormData(addressForm);

    const street = addressData.get("street") || "";
    const street_no = addressData.get("streetNumber") || "";
    const postalCode = addressData.get("postalCode") || "";
    const place = addressData.get("city") || "";

    const fullAddress = `${street} ${street_no}, ${postalCode} ${place}`;

    const li = document.createElement("li");
    li.textContent = fullAddress;
    addressList.appendChild(li);

    setTimeout(() => {
        booking_form.parentElement.classList.remove("sticky");
    }, 50);
}

async function fetchPostcodeLookup(postalCode, streetNumber) {
    try {
        // The postalCode MUST be without spaces
        const normalizedPostal = postalCode.replace(/\s+/g, "");

        const url = new URL(
            "https://phpstack-1418759-5351611.cloudwaysapps.com/api/postcode/lookup"
        );

        url.searchParams.append("postalCode", normalizedPostal);
        url.searchParams.append("streetNumber", streetNumber);

        console.log("🔍 Fetching postcode lookup from:", url.toString());

        const response = await fetch(url.toString(), {
            method: "GET",
            headers: { "Accept": "application/json" }
        });

        const result = await response.json();

        console.group("📬 Postcode Lookup Debug (GET)");
        console.log("Request:", { normalizedPostal, streetNumber });
        console.log("Response:", result);
        console.groupEnd();
        const streetField = document.getElementById("straat");
        const postalField = document.getElementById("Postcode");
        const numberField = document.getElementById("straatnummer");
        if (!result.status) {
            console.error("Lookup failed:", result.error || result.message);
            return;
        }

        const data = result.data || {};

        // Detect PostcodeAPI errors
        const isError = !result.status || data.title || !data.street;

        if (isError) {
            console.error("Lookup failed:", data.title || result.error || "Unknown error");

            markFieldInvalid(postalField, "Adres niet gevonden.");
            markFieldInvalid(numberField);

            // Optional: clear other fields
            document.getElementById("straat").value = "";
            document.getElementById("city").value = "";
            document.getElementById("plaats").value = "";

            return;
        }


        if (streetField) {
            streetField.value = data.street || "";
            streetField.parentElement.hidden = false;
            markFieldValid(streetField);
        }

        const cityField = document.getElementById("city");
        if (cityField) {
            cityField.value = data.city || "";
            cityField.parentElement.hidden = false;
            markFieldValid(cityField);
        }

        const provinceField = document.getElementById("plaats");
        if (provinceField) {
            provinceField.value = data.province || "";
            provinceField.parentElement.hidden = false;
            markFieldValid(provinceField);
        }

        if (postalField && data.postcode) {
            postalField.value = data.postcode.replace(/^([0-9]{4})([A-Z]{2})$/, "$1 $2");
            markFieldValid(postalField);
        }

        if (numberField && data.number) {
            numberField.value = data.number;
            numberField.parentElement.hidden = false;
            markFieldValid(numberField);
        }

        document.querySelector("#address_form .custom-fg").hidden = false;

    } catch (error) {
        console.error("❌ Error fetching address:", error);
    }
}


const postalInput = document.getElementById("Postcode");
const streetNumberInput = document.getElementById("straatnummer");

function tryLookupAddress() {
    const postal = postalInput.value.trim();
    const number = streetNumberInput.value.trim();

    if (!postal || !number) return;

    // CLEAN: 1234AB
    const cleanedPostal = postal.toUpperCase().replace(/\s+/g, "");

    // Style only for UI: 1234 AB
    const formattedPostal = cleanedPostal.replace(
        /^([0-9]{4})([A-Z]{2})$/,
        "$1$2"
    );

    // UI looks nice
    postalInput.value = formattedPostal;

    // API call uses CLEAN (no space)
    fetchPostcodeLookup(cleanedPostal, number);
}

postalInput.addEventListener("blur", tryLookupAddress);
streetNumberInput.addEventListener("blur", tryLookupAddress);

document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.getElementById('interests-toggle');
    const panel = document.getElementById('interests-panel');
    const label = document.getElementById('interests-label');
    const options = panel.querySelectorAll('.interest-option');

    // Open/close dropdown
    toggle.addEventListener('click', function () {
        panel.classList.toggle('hidden');
    });

    // Close when clicking outside
    document.addEventListener('click', function (e) {
        if (!document.getElementById('interests-dropdown').contains(e.target)) {
            panel.classList.add('hidden');
        }
    });

    // Update label text based on selected options
    function updateLabel() {
        const checked = Array.from(options).filter(o => o.checked);
        if (checked.length === 0) {
            label.textContent = 'Kies één of meerdere';
        } else if (checked.length === 1) {
            label.textContent = checked[0].value;
        } else {
            label.textContent = checked[0].value + ' +' + (checked.length - 1);
        }
    }

    options.forEach(opt => {
        opt.addEventListener('change', updateLabel);
    });

    // initial state
    updateLabel();
});

function fireConfetti() {
    if (typeof confetti !== "function") {
        console.warn("confetti is not loaded");
        return;
    }

    confetti({
        particleCount: 140,
        spread: 70,
        origin: { y: 0.6 },
        ticks: 250
    });
}

// ===========================
// Tooltips met HTML content
// ===========================
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".info-icon").forEach((icon) => {
        const html = icon.getAttribute("data-tooltip-html");
        if (!html) return;

        const bubble = document.createElement("div");
        bubble.className = "info-tooltip";
        bubble.innerHTML = html;
        icon.appendChild(bubble);
    });
});

function validatePhoneNumber(el) {
    const group = el.closest(".form-group");
    if (!group) return false;

    const value = el.value.trim();
    const digits = value.replace(/\D/g, ""); // verwijder alles behalve cijfers
    const error = group.querySelector(".error-message");

    // Verwijder oude error
    if (error) error.remove();
    group.classList.remove("invalid");

    if (digits.length < 10) {
        const msg = document.createElement("div");
        msg.className = "error-message text-danger small mt-1";
        msg.textContent = "Voer een geldig telefoonnummer in.";
        group.appendChild(msg);
        group.classList.add("invalid");
        group.classList.remove("valid");
        return false;
    }

    // ✔ geldig nummer → vinkje tonen
    group.classList.add("valid");
    return true;
}

function markFieldValid(input, delay = 250) {
    if (!input) return;
    const group = input.closest(".form-group");
    if (!group) return;

    clearTimeout(group._validationTimeout);

    group._validationTimeout = setTimeout(() => {

        group.querySelectorAll(".error-message").forEach(el => el.remove());

        group.classList.remove("invalid");

        if (input.value.trim() !== "") {
            group.classList.add("valid");
        } else {
            group.classList.remove("valid");
        }

    }, delay);
}

function markFieldInvalid(input, message = null, delay = 250) {
    if (!input) return;
    const group = input.closest(".form-group");
    if (!group) return;

    clearTimeout(group._validationTimeout);

    group._validationTimeout = setTimeout(() => {

        group.classList.remove("valid");
        group.classList.add("invalid");

        group.querySelectorAll(".error-message").forEach(el => el.remove());

        if (message) {
            const error = document.createElement("div");
            error.className = "error-message text-danger small mt-1";
            error.textContent = message;
            group.appendChild(error);
        }

    }, delay);
}

function formatDateForICS(date) {
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const seconds = String(date.getUTCSeconds()).padStart(2, "0");

    return `${year}${month}${day}T${hours}${minutes}${seconds}Z`;
}

function escapeICS(text = "") {
    return String(text)
        .replace(/\\/g, "\\\\")
        .replace(/\n/g, "\\n")
        .replace(/,/g, "\\,")
        .replace(/;/g, "\\;");
}

function downloadICSFile({ title, description, location, startDate, endDate, filename = "afspraak-solerza.ics" }) {
    const icsContent = [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        "PRODID:-//Solerza//Advies Afspraak//NL",
        "BEGIN:VEVENT",
        `UID:${Date.now()}@solerza.nl`,
        `DTSTAMP:${formatDateForICS(new Date())}`,
        `DTSTART:${formatDateForICS(startDate)}`,
        `DTEND:${formatDateForICS(endDate)}`,
        `SUMMARY:${escapeICS(title)}`,
        `DESCRIPTION:${escapeICS(description)}`,
        `LOCATION:${escapeICS(location)}`,
        "END:VEVENT",
        "END:VCALENDAR"
    ].join("\r\n");

    const blob = new Blob([icsContent], { type: "text/calendar;charset=utf-8" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
}

const addToCalendarBtn = document.getElementById("add-to-calendar-btn");

if (addToCalendarBtn) {
    addToCalendarBtn.addEventListener("click", () => {
        if (!selectedCalendarSlot?.etaRange?.from?.date || !selectedCalendarSlot?.etaRange?.to?.date) {
            console.error("Geen geldig tijdslot beschikbaar voor agenda-export.");
            return;
        }

        const startDate = new Date(selectedCalendarSlot.etaRange.from.date);
        const endDate = new Date(selectedCalendarSlot.etaRange.to.date);

        const addressForm = document.getElementById("address_form");
        const addressData = new FormData(addressForm);

        const street = addressData.get("street") || "";
        const streetNo = addressData.get("streetNumber") || "";
        const streetSuffix = addressData.get("streetNumberSuffix") || "";
        const postalCode = addressData.get("postalCode") || "";
        const place = addressData.get("city") || "";

        const location = `${street} ${streetNo}${streetSuffix ? streetSuffix : ""}, ${postalCode} ${place}`.trim();

        const description =
            "Advies- en inmeetafspraak aan huis met Solerza. Dit is een aankomsttijdvak van 3 uur. Je ontvangt 15 tot 30 minuten vooraf een sms zodra onze adviseur onderweg is.";

        downloadICSFile({
            title: "Advies- en inmeetafspraak Solerza",
            description,
            location,
            startDate,
            endDate,
            filename: "solerza-afspraak.ics"
        });
    });
}

document.addEventListener("DOMContentLoaded", () => {
    const icons = document.querySelectorAll(".info-icon");

    function closeAllTooltips(exceptIcon = null) {
        icons.forEach((icon) => {
            if (icon !== exceptIcon) {
                icon.classList.remove("is-open");
            }
        });
    }

    function positionTooltip(icon) {
        const tooltip = icon.querySelector(".info-tooltip");
        if (!tooltip) return;

        tooltip.classList.remove("info-tooltip--bottom", "info-tooltip--align-left");
        tooltip.style.left = "";
        tooltip.style.right = "";
        tooltip.style.top = "";
        tooltip.style.bottom = "";

        const rect = tooltip.getBoundingClientRect();

        // Niet genoeg ruimte boven? Dan onder tonen
        if (rect.top < 10) {
            tooltip.classList.add("info-tooltip--bottom");
        }
    }

    icons.forEach((icon) => {
        const tooltip = icon.querySelector(".info-tooltip");
        if (!tooltip) return;

        // Hover desktop
        icon.addEventListener("mouseenter", () => {
            positionTooltip(icon);
        });

        // Focus toetsenbord
        icon.addEventListener(
            "focus",
            () => {
                positionTooltip(icon);
            },
            true
        );

        // Klik / touch
        icon.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            const willOpen = !icon.classList.contains("is-open");
            closeAllTooltips();

            if (willOpen) {
                icon.classList.add("is-open");
                positionTooltip(icon);
            }
        });
    });

    // Klik buiten tooltip = sluiten
    document.addEventListener("click", () => {
        closeAllTooltips();
    });

    // Escape = sluiten
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
            closeAllTooltips();
        }
    });

    // Reposition bij resize
    window.addEventListener("resize", () => {
        document.querySelectorAll(".info-icon.is-open").forEach((icon) => {
            positionTooltip(icon);
        });
    });

    // Reposition bij scroll
    window.addEventListener(
        "scroll",
        () => {
            document.querySelectorAll(".info-icon.is-open").forEach((icon) => {
                positionTooltip(icon);
            });
        },
        { passive: true }
    );
});